module.exports = __webpack_public_path__ + "img/svdpnsw.51e69e6.png";